export const SPONSORED_PRODUCTS_POSITIONS_A = [0, 1];
export const SPONSORED_PRODUCTS_POSITIONS_B = [0, 1, 2, 3, 4];
export const FBT_PLAYLIST_FULLY_SPONSORED_AB_TEST =
  'fbtPlaylistFullySponsoredAbTest';

export const SPONSORED_FEATURES_FLAGS = [
  'spFeature1',
  'spFeature2',
  'spFeature3',
  'spRerank',
];
